const values = (v) => (Array.isArray(v) ? v : Object.values(v));
/** Every font id a snapshot or compose input can ask the composer for. The server and the portal both use this, so they cannot disagree. */
export function referencedFontIds(input) {
    const ids = new Set();
    for (const s of values(input.paragraphStyles)) {
        if (s.attrs.fontId)
            ids.add(s.attrs.fontId);
        if (s.attrs.bullets?.fontId)
            ids.add(s.attrs.bullets.fontId);
    }
    for (const s of values(input.characterStyles))
        if (s.attrs.fontId)
            ids.add(s.attrs.fontId);
    const stories = [...(input.stories ?? []), ...(input.story ? [input.story] : [])];
    for (const st of stories) {
        for (const p of st.paragraphs) {
            if (p.overrides?.fontId)
                ids.add(p.overrides.fontId);
            if (p.overrides?.bullets?.fontId)
                ids.add(p.overrides.bullets.fontId);
            for (const r of p.runs)
                if (r.overrides?.fontId)
                    ids.add(r.overrides.fontId);
        }
    }
    return ids;
}
const norm = (s) => s.toLowerCase().replace(/[^a-z]/g, '');
/** Face in the same family as `baseFontId` with bold and/or italic applied. Undefined when no such face exists; callers must not invent one. */
export function resolveFace(fonts, baseFontId, opts) {
    if (!opts.bold && !opts.italic)
        return undefined;
    const base = fonts.find((f) => f.id === baseFontId || f.postscriptName === baseFontId);
    if (!base)
        return undefined;
    const baseWords = base.style.split(/\s+/).filter((w) => !/italic|oblique/i.test(w) && !/^regular$|^roman$|^book$/i.test(w));
    const weight = opts.bold ? ['Bold'] : baseWords;
    const wanted = [...weight, ...(opts.italic ? ['Italic'] : [])];
    const target = norm(wanted.join(' ')) || 'regular';
    const candidates = fonts.filter((f) => f.family === base.family);
    return candidates.find((f) => norm(f.style) === target)
        ?? candidates.find((f) => norm(f.style) === (target === 'regular' ? 'roman' : target));
}
/**
 * Is `fontId` bold and/or italic relative to `baseFontId`? The inverse of resolveFace, and the
 * rule that decides which emphasis marks a run travels through the editor with. Kept here so the
 * portal (seeding ProseMirror), the server (seeding a Yjs room) and both materialisers cannot
 * disagree about what a face implies.
 *
 * It is one directional on purpose: there is no mark for "lighter than the paragraph", which is
 * why a run also carries its face verbatim.
 */
export function faceEmphasis(fonts, baseFontId, fontId) {
    const at = (id) => (Array.isArray(fonts) ? fonts.find((f) => f.id === id) : fonts[id]);
    const base = at(baseFontId);
    const face = at(fontId);
    if (!face)
        return { bold: false, italic: false };
    const isBold = /bold|black|heavy/i.test(face.style) && !(base && /bold|black|heavy/i.test(base.style));
    const isItalic = /italic|oblique/i.test(face.style) && !(base && /italic|oblique/i.test(base.style));
    return { bold: isBold, italic: isItalic };
}
//# sourceMappingURL=fonts.js.map